// @flow
import * as React from "react";
import PropTypes from "prop-types";
import { withColorsProvider, type ColorSet } from "../ColorsProvider";
import Dialog from "../Dialog";
import ItemList from "../ItemList";
import ScrollableDiv from "../ScrollableDiv";

export type valueType = string | number | boolean;
export const valuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

export type Option = {
  id?: string | number,
  value: valueType,
  label: React.Node, // I was unable to get generics working with this. If you *need* your label to be a string, just manipulate the type inline
  isPivot?: boolean,
  onTap?: () => void,
  header?: boolean,
  info?: boolean,
};

export type Props = {
  options: Array<Option>,
  value: ?valueType,
  onOptionTapped?: ?(Option) => void,
  onBackgroundTapped?: ?() => void,
  onRequestClose?: ?() => void,
  open?: boolean,
  colors: ColorSet,
};

class SelectDialog extends React.Component<Props> {
  static defaultProps = {
    options: [],
  };

  render() {
    const {
      options,
      value,
      onOptionTapped,
      onBackgroundTapped,
      onRequestClose,
      open,
      colors,
    } = this.props;

    const styles = {
      dialog: {
        minWidth: "10em",
        maxWidth: "90vw",
        maxHeight: "75vh",
      },
      item: {
        padding: "0 1em",
      },
    };

    const containsHeader = options.find((option) => {
      return Boolean(option.header);
    });

    const optionStyle = (option) => {
      const isHeader = Boolean(option.header);
      const isInfo = Boolean(option.info);
      const isSelectAll = value === "Select All";
      const isSelectedValue = value === option.value;
      return {
        ...styles.item,
        ...(isSelectedValue
          ? {
              color: colors.PRIMARY,
              backgroundColor: "#f3f3f3",
            }
          : null),
        ...(containsHeader && isSelectAll
          ? {
              paddingLeft: ".5em",
            }
          : null),
        ...(containsHeader && isHeader
          ? {
              fontWeight: "bold",
              fontSize: ".8em",
            }
          : null),
        ...(isInfo
          ? {
              fontSize: ".8em",
            }
          : null),
        ...(containsHeader && !isHeader && !isInfo
          ? {
              paddingLeft: "1.5em",
            }
          : null),
      };
    };

    return (
      <Dialog
        open={open}
        onTapBackground={onBackgroundTapped}
        onRequestClose={onRequestClose}
      >
        <ScrollableDiv style={styles.dialog}>
          <ItemList
            id="select-options"
            items={options.map((option, index) => ({
              id: option.id || `${index}`,
              label: option.label,
              style: {
                ...optionStyle(option),
              },
              onTap:
                option.header || option.info
                  ? null
                  : option.onTap ||
                    (() => onOptionTapped && onOptionTapped(option)),
            }))}
          />
        </ScrollableDiv>
      </Dialog>
    );
  }
}

export default withColorsProvider(SelectDialog);



// WEBPACK FOOTER //
// ../nx-components/src/Select/SelectDialog.jsx